import { gql } from '@apollo/client'

const GET_NOTIFICATIONS = gql`
  query getNotifications($stripeConnectId: String!) {
    getNotifications(stripeConnectId: $stripeConnectId) {
      type
      details {
        last4
      }
    }
  }
`

export default GET_NOTIFICATIONS
